import UserModel from "@/models/server/UserModel";
import {ApplicationContext, IUserContext} from "@renta-apps/athenaeum-react-common";
import ApplicationSettings from "@/models/server/ApplicationSettings";
import UserRoleModel from "@/models/server/UserRoleModel";
import UserRole from "@/models/server/UserRole";
import {RolePermission} from "@/models/Enums";

export default class UserContext extends ApplicationContext implements IUserContext<ApplicationSettings, UserModel> {

    /**
     * Can the user see prices in their currently selected Contract or Construction Site.
     */
    public canSeePrices: boolean = false;

    /**
     * Can the user manage (invite) other users to the currently selected Contract or Construction Site.
     */
    public canManageUsers: boolean = false;

    public user: UserModel | null = null;

    public dateTime: Date | null = null;

    /**
     * Users email address.
     */
    public username: string = this.user!.username;

    /**
     * Is the users currently selected role Admin or Office user.
     * NOTE: Admin has full rights to everything, while Office user has limited rights to selected depots only.
     * They are both considered as admins from business point of view, hence this property is true for both of them.
     * If checking strictly for the top-level Admin-role is needed, use {@link isAdminWithAdminRole} instead.
     */
    public isAdmin: boolean = false;

    /**
     * Is the users currently selected role Admin.
     * NOTE: Business-wise Office-users are also "admins", but this prop is only true for top-level Admins.
     * If checking for both Admins and Office-users is needed, use {@link isAdmin} instead.
     */
    public isAdminWithAdminRole: boolean = false;

    /**
     * Does the user have access to admin functionality on some role. This does not equal to {@link isAdmin} or {@link isAdminWithAdminRole} check
     * and should not be used to as a role check
     */
    public hasAdminRole: boolean = false;

    /**
     * Does the user have access to admin functionality on some role. This does not equal to {@link isAdminWithAdminRole} check
     * and should not be used to as a role check
     */
    public hasAdminWithAdminRole: boolean = false;

    public isEasyPlusUser: boolean = false;

    public selectedRole: UserRole | null = null;

    public isPrivateUser: boolean = false;

    public isOrganizationMainUser: boolean = false;
    
    public isOrganizationContractMainUser: boolean = false;

    public isConstructionSiteUser: boolean = false;

    public isSingleConstructionSiteMainUserUser: boolean = false;

    public isConstructionSiteMainUser: boolean = false;

    public selectedRoleId: string | null = null;

    public selectedContractName: string | null = null;

    public currentRoleName: string | null = null;

    public selectedConstructionSiteName: string | null = null;

    public isPullRequest: boolean = false;

    public isLocalDevelopment: boolean = true;

    /**
     * Easy Id of the contract the Renta user is making an order for.
     */
    public temporaryContractIdForPrices: string | null = null;

    /**
     * Name of the contract the Renta user is making an order for.
     */
    public temporaryContractNameForPrices: string = "";

    /**
     * Easy Id of the construction site the Renta user is making an order for.
     */
    public temporaryConstructionSiteIdForPrices: string | null = null;

    /**
     * Name of the construction site the Renta user is making an order for.
     */
    public temporaryConstructionSiteNameForPrices: string = "";

    public readonly isUserContext: true = true;
}

export function hasFlag(permissions: RolePermission | undefined | null, flag: RolePermission): boolean {
    return ((permissions ?? 0) & flag) === flag;
}